<template>
    <div class="content-box">
        <div class="header-box">
            <img src="../assets/logo.png" alt="" style="margin-top: 50px;width: 96px;height: 96px;">
            <div style="color: white;font-size: 25px;font-weight: 900;margin-top: 20px;margin-bottom: 30px;">Sweet Color:Coloring games</div>
            <div class="header-text">Relax and Unwind with soothing Color</div>
            <div class="header-text">Sweet Coloring Games</div>
            <div class="download-btn">
                <a class="download-a" href="https://play.google.com/store/apps/details?id=com.sweet.coloring.book.paint.by.number.puzzle.game">
                    Download
                </a>
            </div>
        </div>

        <div class="sub-title">Color Your Day with Sweet Color</div>
        <div class="sub-title2">🎉 Get ready to unleash your creativity, reduce stress, and start your day with a smile.😊</div>
        <div class="sub-title2">A number coloring book and coloring puzzle game for everyone.</div>

        <div class="noticeListBox">
                <img class="item-img" src="../assets/screen_1.jpg">
                <img class="item-img" src="../assets/screen_2.jpg">
                <img class="item-img" src="../assets/screen_3.jpg">
                <img class="item-img" src="../assets/screen_4.jpg">
        </div>

        <div style="font-size: 13px;">Contact us @gmail.com.</div>


    </div>
</template>


<script>
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import url("//unpkg.com/element-plus/lib/theme-chalk/index.css");

    .header-box {
        text-align: center;
        background-color: #CE6478;
    }

    .header-text {
        font-size: 25px;
        color: rgba(255, 255, 255, 0.9);
        font-weight: 700;

    }

    .download-btn {
        display: inline-block;
        text-align: center;
        background-color: #2AC837;
        width: 172px;
        height: 56px;
        margin: 30px 0 30px 0;
        border-radius: 28px;

    }

    .download-a {
        line-height: 56px;
        font-size: 17px;
        color: white;
        font-weight: 700;
        text-align: center;
    }

    .item-img{
        background-color: yellow;
        margin: 0 20px;
        display: inline-block;
        /*height: 300px;*/
        width: 200px;
    }

    .noticeListBox{
        margin: 50px 20px 50px 20px;
        width: 100%;
        height: 500px;
        overflow: scroll;
        white-space: nowrap;
    }
    .noticeListBox::-webkit-scrollbar {
        display: none;
    }
    .sub-title{
        font-size: 27px;
        font-weight: 900;
        color: #000;
        margin: 20px;
    }
    .sub-title2{
        font-size: 17px;
        color: #222;
    }


</style>
